export class FooterHorizontalNavigation {
    constructor(containerSelector, leftArrowSelector, rightArrowSelector, navigationSelector) {
        this.navigation = document.querySelector(navigationSelector);

        if (!this.navigation) {
            return;
        }

        this.container = this.navigation.querySelector(containerSelector);
        this.leftArrow = this.navigation.querySelector(leftArrowSelector);
        this.rightArrow = this.navigation.querySelector(rightArrowSelector);

        if (this.container && this.leftArrow && this.rightArrow) {
            this.init();
        }
    }

    init() {
        //console.log('Initializing FooterHorizontalNavigation');

        this.leftArrow.addEventListener('click', () => this.scrollLeft());
        this.rightArrow.addEventListener('click', () => this.scrollRight());

        this.updatePaddles();
    }

    scrollLeft() {
        //console.log('Scrolling left');
        this.container.scrollBy({
            left: -this.container.clientWidth,
            behavior: 'smooth'
        });
        this.updatePaddles();
    }

    scrollRight() {
        //console.log('Scrolling right');
        this.container.scrollBy({
            left: this.container.clientWidth,
            behavior: 'smooth'
        });
        this.updatePaddles();
    }

    updatePaddles() {
        const scrollLeft = this.container.scrollLeft;
        const maxScrollLeft = this.container.scrollWidth - this.container.clientWidth;

        //console.log('Update Paddles:', { scrollLeft, maxScrollLeft });

        if (scrollLeft <= 0) {
            //console.log('Hiding left arrow');
            this.leftArrow.classList.add('hidden');
            this.rightArrow.classList.remove('hidden');
        } else if (scrollLeft >= maxScrollLeft) {
            //console.log('Hiding right arrow');
            this.leftArrow.classList.remove('hidden');
            this.rightArrow.classList.add('hidden');
        } else {
            this.leftArrow.classList.remove('hidden');
            this.rightArrow.classList.remove('hidden');
        }
    }
}

// Initialize the FooterHorizontalNavigation class
document.addEventListener('DOMContentLoaded', () => {
    new FooterHorizontalNavigation('.wp-block-navigation__container', '.nav-arrow.left', '.nav-arrow.right', '.footer-horizontal-nav');
});
